import React, { useContext, useEffect, useMemo, useState } from "react";

import useMeasure from "react-use-measure";

import eventEmitter from "@app/contexts/emitter";

import type { THelpNamespace } from "@app/types/insider";
type IChildContext = Record<string, { height: number }>;

interface IHelpContext {
  showPage: { [key: string]: boolean };
  helpState: IChildContext;
  toggleShowPage: (key: string) => void;
  heights: number[];
  measuredPageHeight: (key: string, height: number) => void;
}
export const HelpContext = React.createContext<IHelpContext>({} as any);
export const HelpContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [helpState, setHelpContext] = useState<IChildContext>({});
  const [showPage, setShowPage] = useState({});

  const heights = useMemo(
    () => Object.values(helpState).map((h) => h?.height || 0),
    [helpState]
  );
  const measuredPageHeight = (key: string, height: number) => {
    setHelpContext((prev) => ({
      ...prev,
      [key]: {
        height,
      },
    }));
  };
  const toggleShowPage = (key: string) => {
    setShowPage((prev: { [key: string]: boolean }) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const emmShowPage = (o: { [key: string]: boolean }) => {
    const [key, value] = Object.entries(o)[0];
    setShowPage((prev) => ({ ...prev, [key]: value }));
  };
  useEffect(() => {
    eventEmitter.on("HELP_PAGE_SHOW", emmShowPage);
    return () => {
      eventEmitter.off("HELP_PAGE_SHOW", emmShowPage);
    };
  }, []);
  return (
    <HelpContext.Provider
      value={{
        showPage,
        helpState,
        toggleShowPage,
        heights,
        measuredPageHeight,
      }}
    >
      {children}
    </HelpContext.Provider>
  );
};
export const useHelpContext = () => useContext(HelpContext);

export const useHelpPage = (keyName: THelpNamespace) => {
  const { measuredPageHeight } = useHelpContext();
  const [ref, { height, width }] = useMeasure();
  const maxImageWidth = width - 120;
  useEffect(() => {
    measuredPageHeight(keyName, height);
  }, [height]);
  return { ref, maxImageWidth };
};
